import type { SignInWithSSO } from '@supabase/supabase-js';

import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

/**
 * Start a SAML 2.0 single sign-on flow.
 *
 * Unlike every other sign-in mutation in this directory, this one does NOT
 * establish a session — it returns the identity provider's URL and the caller
 * navigates there. The session is created much later, by GoTrue, when the
 * provider POSTs its assertion back to the ACS endpoint, and reaches the app
 * as a code on `/auth/callback`.
 *
 * That is why the mutation resolving is not success in any useful sense: the
 * flow has barely started. The caller must redirect.
 */
export function useSignInWithSSO() {
  const client = useSupabase();
  const mutationKey = ['auth', 'sign-in-with-sso'];

  const mutationFn = async (credentials: SignInWithSSO) => {
    const response = await client.auth.signInWithSSO(credentials);

    if (response.error) {
      throw response.error;
    }

    return response.data;
  };

  return useMutation({
    mutationFn,
    mutationKey,
  });
}
